const PDR_FORM = 'pdr'

export const isPdrOrder = (order) => {
  if (!order) {
    return false
  }
  return !!order.products?.find(product => product?.included_forms?.includes(PDR_FORM))
}
